import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, Validator, ValidationErrors, ValidatorFn } from '@angular/forms';

export function numberValidator(): ValidatorFn {

  const NUMBER_REGEXP = /^[0-9]*$/i;

  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = NUMBER_REGEXP.test(control.value);

    if (isValid) {
      return null;
    } else {
      return {
        numberValidator: {
          valid: false,
        },
      };
    }
  };

}

@Directive({
  selector: '[appNumberValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: NumberValidatorDirective,
    multi: true,
  }],
})
export class NumberValidatorDirective implements Validator {

  constructor() {
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    return numberValidator()(control);
  }

}